import {Pie, Bar} from 'react-chartjs-2'
import {Chart, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title} from 'chart.js'
import {Row, Col} from 'react-bootstrap'
Chart.register( ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);

function ReporteVentasChartJS({ventas}) {
    function generarNuevoColor () {
        var simbolos, color;
        simbolos = "0123456789ABCDEF";
        color = "#";
        for(var i = 0; i < 6; i++){
            color = color + simbolos[Math.floor(Math.random() * 16)];
        }
        return color
    }

    const dataVentas = {
        labels: ventas.map(v=> {
            return v.marca
        }),
        datasets : [{
            label : "Ventas por Marca",
            data : ventas.map(v=> {return v.ventas}),
            backgroundColor: ventas.map((elem) => elem.color ? elem.color : generarNuevoColor())
        }]
    }

    const dataComisiones = {
        labels: ventas.map(v=> {
            return v.marca
        }),
        datasets : [{
            label: "Comisiones por Marca",
            data : ventas.map(v=> {return v.comisiones}),
            backgroundColor: ventas.map((elem) => elem.color ? elem.color : generarNuevoColor())
        }]
    }
    
    const totalVentas = ventas.reduce((total, venta) => total + parseFloat(venta.ventas), 0);
    const opcionesVentas = {
        responsive : true,
        plugins: {
            legend: {
              position: 'top',
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const valor = tooltipItem.raw;
                        const porcentaje = ((valor / totalVentas) * 100).toFixed(2); // Calcula el porcentaje
                        return `${porcentaje}% (${valor})`;
                    },
                },
            },
            title : {
                display : true,
                text: "Ventas totales por Marca"
            }
        }
    }

    const totalComisiones = ventas.reduce((total, venta) => total + parseFloat(venta.comisiones), 0);
    const opcionesComisiones = {
        responsive : true,
        plugins: {
            legend: {
              position: 'top',
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const valor = tooltipItem.raw;
                        const porcentaje = ((valor / totalComisiones) * 100).toFixed(2); // Calcula el porcentaje
                        return `${porcentaje}% (${valor})`;
                    },
                },
            },
            title : {
                display : true,
                text: "Comisiones totales por Marca"
            }
        }
    }

    const isMobile = window.innerWidth < 768;
    const dataClientesActivos = {
        labels: ventas.map(v=> {return v.marca}),
        datasets: [
          {
            label: 'Cant.Clientes',
            data: ventas.map(v => {return v.clientes_activos}),
            backgroundColor: ventas.map((elem) => elem.color ? elem.color : generarNuevoColor()), // Color de las barras
            borderColor: 'rgba(75, 192, 192, 1)', // Color del borde de las barras
            borderWidth: 1,
            barThickness: isMobile ? 10 : 30
          },
        ],
      };
      const optionsClientesActivos = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top', // Posición de la leyenda
          },
          title: {
            display: true,
            text: 'Clientes Activos por Marca', // Título de la gráfica
          },
        },
        scales: {
          y: {
            beginAtZero: true, // Empezar en 0 en el eje Y
          },
        },
      };
  return (
    <>
        <Row>
            <Col md="6" xs="12">
                <div style={{ width: '300px', height: '300px' }}>
                    <Pie data={dataVentas} options={opcionesVentas}/>
                </div>
            </Col>
            <Col md="6" xs="12">
                <div style={{ width: '300px', height: '300px' }}>
                    <Pie data={dataComisiones} options={opcionesComisiones}/>
                </div>
            </Col>
        </Row>
        <div style={{ width: '100%', height: '300px' }}>
            <Bar data={dataClientesActivos} options={optionsClientesActivos} />
        </div>
    </>
  )
}

export default ReporteVentasChartJS